import React, { Component } from 'react'
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import News from '../components/News';
import PageIntro from '../components/PageIntro';
import QuickContact from '../components/QuickContact';
import Testimonies from '../components/Testimonies';
import '../../assets/main/css/testimonials.css'

class Testimonials extends Component {
    
    render() {
        return (
            <>
                <Header />
                <PageIntro intro="We define our Success by your results" design="pages-head2" title="Affiliates and Customer View" />
                <Testimonies />
                <QuickContact />
                <News feeds={this.props.news} desc="Latest News" btn="See More" btnLink="/blog" />
                <Footer />
            </>
        )
    }
}

export default Testimonials
